import type {
  LoadFlowScenarioResults,
  CalculationScenarioAvailability
} from '../../index';

export function getLoadFlowAvailability(
  loadFlow: LoadFlowScenarioResults[]
): CalculationScenarioAvailability<'LOAD_FLOW'> {
  return loadFlow.some(
    loadflowScenario => loadflowScenario.status === 'Completed'
  )
    ? { type: 'AVAILABLE', calculationType: 'LOAD_FLOW' }
    : { type: 'NOT_AVAILABLE' };
}
